import { IRepositoryEntry, IRepositoryFolder } from '@/types';
import { fetchWrapper, IBaseResponse, extractPaginationInfo } from './apiBase';
import { BASE_API_URL } from '@/config/environment';

export interface IRepositoryFolderResponse extends IBaseResponse, IRepositoryFolder { }

const responseHandler = (res: any): IRepositoryFolderResponse => {
  const { entries, dir, resource, status, status_message, error } = res;
  const pagination = extractPaginationInfo(res);
  // console.log('responseHandler > res.data', res.data);
  return {
    status,
    status_message,
    entries: entries || [],
    dir,
    resource: resource || null,
    pagination,
    error: error || null,
  };
};

const delayFetch = (url: string, options: any): Promise<Response> =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(fetch(url, options));
    }, options.delay);
  });

export const fetchRepositoryFolder = async (
  namespace: string,
  repositoryName: string,
  resource: string,
  pageNum: number,
  token?: string,
): Promise<IRepositoryFolderResponse> => {
  const targetUrl = `${BASE_API_URL}/repos/${namespace}/${repositoryName}/dir/${resource}?page=${pageNum}`;

  const data = await fetchWrapper({
    resourceName: 'repositoryFolder',
    targetUrl,
    authToken: token,
    resourceContext: { namespace, repositoryName, resource },
  });
  return responseHandler(data);
};

export const findReadmeInFolder = (entries: IRepositoryEntry[] | undefined) => {
  // TODO: this is a hack to find the readme file in a folder - we should have a better way to do this from the API
  return entries?.find((e) => e.filename.toLowerCase() == 'readme' || e.filename.toLowerCase() == 'readme.md');
};
